export interface Right { [permission: string]: boolean; }
export interface RolePermission { [role: string]: Right; }

export const RIGHT_KEYS = {
    TestHarnessAccess: 'TestHarness.Access',
    LabAccess: 'Lab.Access',
    LabAccessAll: 'Lab.AccessAll',
    LabAdd: 'Lab.Add',
    LabAccessExpired: 'Lab.AccessExpired',
    UserManagement: 'Lab.UserManagement',
};

export const ROLE_NAME = {
    Admin: 'Admin',
    BioRadUser: 'BioRadUser',
    LabUser: 'LabUser'
};

// This should come from back end or token
export const ROLE_PERMISSIONS: RolePermission = {
    'Admin': {
        'TestHarness.Access': true,
        'Lab.Access': true,
        'Lab.AccessAll': true,
        'Lab.Add': true,
        'Lab.AccessExpired': true,
        'Lab.UserManagement': true,
    },

    'BioRadUser': {
        'Lab.Access': true,
        'Lab.AccessExpired': true,
        'Lab.Add': true,
        'Lab.UserManagement': true
    },

    'LabUser': {
        'Lab.Access': true
    }
};



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/security.const.ts